export * from "./companies";
export * from "./endpoints";
export * from "./facilities";
export * from "./users";
export * from "./inquiries";

export type PartialOrNull<T> = {
  [P in keyof T]?: T[P] | null;
};
